import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source, Image } from 'react-mapbox-gl'
import * as ReactMapboxGl from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import { withSnackbar } from 'notistack'
import copy from 'copy-to-clipboard'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetFilter } from '../selectors/filterSelector'
import DataActions from '../redux/dataRedux'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import getFeaturesAtPoint from '../utility/getFeaturesAtPoint'
import getDatetimeForVectorTiles from '../utility/getDatetimeForVectorTiles'
import { EnergirChange as paint } from './paints'
import removeLayers from '../utility/removeLayers'
import addSvgToMap from '../utility/addSvgToMap'
import disturbance from '../assets/map-icons/disturbance.svg'

const id = 'EnergirChange'
const datetimeId = 'Energir'
const authId = 'Energir'
const sourceLayer = 'energir-change'
const paintId = 'EnergirChange'
window.disturbance = disturbance
window.ReactMapboxGl = ReactMapboxGl

const energirHazardMetadata = [
  {
    value: 10,
    color: 'red'
  },
  {
    value: 30,
    color: 'yellow'
  },
  {
    value: 100,
    color: 'blue'
  },
  {
    value: 300,
    color: 'green'
  }
]


const paintOutline = {
  'line-opacity': 1,
  'line-width': 4,
  'line-color': [
    'interpolate',
    ['linear'],
    ['number', ['get', 'difference']],
    -2,
    'red',
    -1,
    'orange',
    0,
    'white',
    100,
    'orange',
    1000,
    'red'
  ]
}

const filterFunction = ({ value = 0, property = 'CHANGE' }) => {
const filter = ['all', ['any', ['>=', property, (value)]] ]

  return filter
}

export class EnergirChange extends Component {
  state = {
    currentTime: new Date().getTime(),    
    times: [
      {
        time: new Date('2019-08-10').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-08-10/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-08-10/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-08-10').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-08-10/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-08-10').getTime()
          }
        }
      },
      {
        time: new Date('2019-08-03').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-08-03/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-08-03/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-08-03').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-08-03/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-08-03').getTime()
          }
        }
      },
      {
        time: new Date('2019-07-27').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-27/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-07-27/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-07-27').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-27/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-07-27').getTime()
          }
        }
      },
      {
        time: new Date('2019-07-20').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-20/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-07-20/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-07-20').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-20/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-07-20').getTime()
          }
        }
      },
      {
        time: new Date('2019-07-13').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-13/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-07-13/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-07-13').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-13/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-07-13').getTime()
          }
        }
      },
      {
        time: new Date('2019-07-06').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-06/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-07-06/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-07-06').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-07-06/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-07-06').getTime()
          }
        }
      },
      {
        time: new Date('2019-06-29').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-29/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-06-29/{z}/{x}/{y}.pbf`,
            // url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-29/energir-hazard.geojson',
            property: 'CHANGE',
            time: new Date('2019-06-29').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-29/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-06-29').getTime()
          }
        }
      },
      {
        time: new Date('2019-06-22').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-22/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-06-22/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-06-22').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-22/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["==", "report", "Y"],
            time: new Date('2019-06-22').getTime()
          }
        }
      },
      {
        time: new Date('2019-06-15').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-15/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-06-15/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-06-15').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-15/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-06-15').getTime()
          }
        }
      },
      {
        time: new Date('2019-06-08').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-08/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-06-08/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-06-08').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-08/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-06-08').getTime()
          }
        }
      },
      {
        time: new Date('2019-06-01').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-01/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-06-01/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-06-01').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-06-01/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-06-01').getTime()
          }
        }
      },
        {
          time: new Date('2019-05-25').getTime(),
          data: {
            'energir-hazard': {
              id: 'energir-hazard',
              url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-25/energir-hazard.geojson'
            }
          },
          layers: {
            'energir-change': {
              id: 'energir-change',
              url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-05-25/{z}/{x}/{y}.pbf`,
              property: 'CHANGE',
              time: new Date('2019-05-25').getTime()
            },
            'energir-hazard': {
              id: 'energir-hazard',
              url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-25/{z}/{x}/{y}.pbf`,
              property: 'distance',
              filter: ["!=", "report", "N"],
              time: new Date('2019-05-25').getTime()
            }
          }
        },
      {
        time: new Date('2019-05-18').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-18/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-05-18/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-05-18').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-18/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-05-18').getTime()
          }
        }
      },
      {
        time: new Date('2019-05-11').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-11/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-05-11/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-05-11').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-11/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-05-11').getTime()
          }
        }
      },
      {
        time: new Date('2019-05-04').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-04/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-05-04/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-05-04').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-05-04/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-05-04').getTime()
          }
        }
      },
      {
        time: new Date('2019-04-27').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-27/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-04-27/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-04-27').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-27/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-04-27').getTime()
          }
        }
      },
      {
        time: new Date('2019-04-20').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-20/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-04-20/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-04-20').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-20/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-04-20').getTime()
          }
        }
      },
      {
        time: new Date('2019-04-13').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-13/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-04-13/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-04-13').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-13/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-04-13').getTime()
          }
        }
      },
      {
        time: new Date('2019-04-06').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-06/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-04-06/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-04-06').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-04-06/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-04-04').getTime()
          }
        }
      },
      {
        time: new Date('2019-03-30').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-30/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-03-30/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-03-30').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-30/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-03-30').getTime()
          }
        }
      },
      {
        time: new Date('2019-03-23').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-23/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-03-23/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-03-23').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-23/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-03-23').getTime()
          }
        }
      },
      {
        time: new Date('2019-03-16').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-16/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-03-16/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-03-16').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-16/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-03-16').getTime()
          }
        }
      },
      {
        time: new Date('2019-03-09').getTime(),
        data: {
          'energir-hazard': {
            id: 'energir-hazard',
            url: 'https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-09/energir-hazard.geojson'
          }
        },
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-03-09/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-03-09').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-09/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-03-09').getTime()
          }
        }
      },
      {
        time: new Date('2019-03-03').getTime(),
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-03-23/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-03-03').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-03-03/{z}/{x}/{y}.pbf`,
            property: 'distance',
            filter: ["!=", "report", "N"],
            time: new Date('2019-03-03').getTime()
          }
        }
      },
      {
        time: new Date('2019-02-24').getTime(),
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-02-24/raw/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-02-24').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-02-24/{z}/{x}/{y}.pbf`,
            property: 'NEAR_DIST',
            filter: ["!=", "Report", "N"],
            time: new Date('2019-02-24').getTime()
          }
        }
      },
      {
        time: new Date('2019-02-17').getTime(),
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-02-17/raw/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-02-17').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-02-17/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            filter: ["!=", "Report", "N"],
            time: new Date('2019-02-02').getTime()
          }
        }
      },
      {
        time: new Date('2019-02-02').getTime(),
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2019-02-02/raw/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-02-02').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-02-02/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2019-02-02').getTime()
          }
        }
      },
      {
        time: new Date('2018-07-14').getTime(),
        layers: {
          'energir-change': {
            id: 'energir-change',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-change/2018-07-14/{z}/{x}/{y}.pbf`,
            property: 'DN',
            time: new Date('2018-07-14').getTime()
          },
          'energir-hazard': {
            id: 'energir-hazard',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/2019-02-02/{z}/{x}/{y}.pbf`,
            property: 'CHANGE',
            time: new Date('2018-07-14').getTime()
          }
        }
      }
    ]
  }

  getDataUrl = ({ time, id }) => {
    if (!time) {
      return null
    }

    const { times } = this.state

    const item = times.find(item => time >= item.time)

    const url = item && item.data ? item.data[id].url : null

    return url
  }

  getLayerUrl = ({ time, id }) => {
    const { times } = this.state

    const item = times.find(item => time >= item.time)

    const url = item ? item.layers[id].url : times[0].layers[id].url

    return url
  }

  getLayerProperty = ({ time, id }) => {
    const { times } = this.state

    const item = times.find(item => time >= item.time)
    const property = item ? item.layers[id].property : times[0].layers[id].property

    return property
  }

  getLayerFilter = ({ time, id }) => {
    const { times } = this.state

    const item = times.find(item => time >= item.time)
    const filter = item ? item.layers[id].filter : times[0].layers[id].filter

    return filter || null
  }

  componentWillMount () {
    const { map } = this.context

    addSvgToMap({ id: 'disturbance', svgData: disturbance, map })
  }

  componentDidMount () {
    const { map } = this.context
    if (!map) { return }

    // map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('mousemove', id, this.handleMouseMove)
    map.on('mouseout', 'energir-hazard', this.handleMouseOut)
    map.on('mousemove', 'energir-hazard', this.handleMouseMove)
    map.on('click', 'energir-hazard', this.handleClick)

    // console.log(map.getStyle().layers)

    
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    // map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('mousemove', id, this.handleMouseMove)
    map.off('mouseout', 'energir-hazard', this.handleMouseOut)
    map.off('mousemove', 'energir-hazard', this.handleMouseMove)
    map.off('click', 'energir-hazard', this.handleClick)
  }

  handleMouseOut = event => {
    const { map } = this.context
    const { actions } = this.props


    map.getCanvas().style.cursor = ''
    actions.dataUpdated({}, 'hover')
  }
  
  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id, 'energir-hazard']
    })

    const data = features.map(feature => feature.properties)

    if (data) {
      actions.dataUpdated(data[0], 'hover')
    }

    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleClick = event => {
    const { map } = this.context
    const { lngLat: { lng, lat } } = event

    const features = map.queryRenderedFeatures(event.point, {
      layers: ['energir-hazard']
    })

    if(features) {
      const feature = features[0]
      const { longitude, latitude } = feature.properties
      const coordinates = `${latitude}, ${longitude}`
      copy(coordinates)
      this.props.enqueueSnackbar(`📋 Copied to clipboard: ${coordinates} .`)
    }    
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.time !== this.props.time) {
      return true
    } else if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.filter !== this.props.filter) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, filter, time, datetime } = this.props
    const { map } = this.context
    const idDemo = `${id}Demo`

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
        // console.log(id, key, paintDiff[key])
        if (key == 'fill-opacity') {
          // map.getLayer(idDemo) && map.setPaintProperty(idDemo, key, paintDiff[key])
        }
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      !isEqual(props.time, time) || !isEqual(props.filter, filter)
    ) {
      // const nextFilter = this.getLayerFilter({ id: 'energir-change', time: time })
      // map.getLayer('energir-change') && map.setFilter('energir-change', nextFilter)
      // datetimeFilterFunction(datetime)
      // map.getLayer(id) && map.setFilter(id, datetimeFilterFunction(props.datetime, filter))
      // map.getLayer(idDemo) && map.setFilter(idDemo, datetimeFilterFunctionDemo(props.datetime, filter))
      // map.getLayer(`${id}Outline`) && map.setFilter(`${id}Outline`, filterFunction(filter, datetime))
    }

    if (
      !isEqual(props.filter, filter)
    ) {
      map.getLayer(id) && map.setFilter(id, filterFunction({ value: props.filter, property: this.getLayerProperty({ id: 'energir-change', time: time }) }))
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }

    if (!isEqual(props.time, time)) {
      const url = this.getDataUrl({ id: 'energir-hazard', time: props.time })
      if (url) {
        fetch(url)
          .then(response => response.json())
          .then(data => this.props.actions.energirHazardDataUpdated(data))
          .catch(error => console.warn(error))
      } else {
        this.props.actions.energirHazardDataUpdated(null)
      }
    }
  }

  render () {
    const { idToken, layerRendered, time, datetime, filter } = this.props
    const visible = layerRendered

    const timeIso = time ? new Date(time).toISOString() : ''
    const filterHazard = this.getLayerFilter({ id: 'energir-hazard', time: time }) || ["!=", "report", "N"]

    const url = this.getLayerUrl({ id: 'energir-change', time: time })
    const geojson = url.endsWith('json')
    const vectorSource = geojson 
    ? 
    {
      type: 'vector',
      url: url
    }
    :
    {
      type: 'vector',
      tiles: [this.getLayerUrl({ id: 'energir-change', time: time })],
      tileSize: 512,
      minZoom: 1,
      maxZoom: 22
    }

    if (!visible || !time) {
      return null
    }

    return (
      <Fragment>
        <Source id={id} tileJsonSource={vectorSource} />        
        <Layer
          type='fill'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paint({ property: this.getLayerProperty({ id: 'energir-change', time: time }) })}
      // before={'Energir-mask'}
        />
        <Source id={'energir-hazard'} tileJsonSource={{
          type: 'vector',
          // tiles: [`https://coresight-layers.s3-us-west-2.amazonaws.com/energir-hazard/{z}/{x}/{y}.pbf`],p
          tiles: [this.getLayerUrl({ id: 'energir-hazard', time: time })],
          tileSize: 512,
          minzoom: 6,
          maxzoom: 6        
        }} />
        <Layer
          type='circle'
          id={'energir-hazard'}
          sourceId={'energir-hazard'}
          sourceLayer={'energir-hazard'}
          filter={filterHazard}
          minzoom={0}
          minZoom={0}
          maxzoom={24}
          maxZoom={24}
          paint={{            
            'circle-radius': 10,
            'circle-stroke-color': [
              'step',
              ['to-number', ['get', this.getLayerProperty({ id: 'energir-hazard', time: time })]],
              '#F90103',
              10, '#FFAA03',
              30, '#FDFE03',
              100, '#55FE01',
              300, '#55FE01'
              ],
            'circle-stroke-width': 1,
            'circle-color': 'rgba(0, 0, 0, 0)'
          }}
          // before={'Energir-mask'}          
        />
        <Layer
          type='symbol'
          id={'energir-hazard-text'}
          sourceId={'energir-hazard'}
          sourceLayer={'energir-hazard'}
          filter={filterHazard}
          minzoom={0}
          minZoom={0}
          maxzoom={24}
          maxZoom={24}
          layout={{
            'text-field': ['get', 'event_id'],
            'text-justify': 'right',
            'text-offset': [5, 2]            
          }}
          paint={{
            'text-color': 'white',
            /* 'text-color': [ */
            /*   'step', */
            /*   ['to-number', ['get', this.getLayerProperty({ id: 'energir-hazard', time: time })]], */
            /*   '#F90103', */
            /*   10, '#FFAA03', */
            /*   30, '#FDFE03', */
            /*   100, '#55FE01', */
            /*   300, '#55FE01' */
            /* ], */
            'text-halo-width': 0.5,
            'text-halo-blur': 0.5,
            'text-halo-color': [
              'step',
              ['to-number', ['get', this.getLayerProperty({ id: 'energir-hazard', time: time })]],
              '#F90103',
              10, '#FFAA03',
              30, '#FDFE03',
              100, '#55FE01',
              300, '#55FE01'
            ]
          }}
      // before={'Energir-mask'}          
        />
        {/* <Image id={'image-1'} url={'/map-icons/disturbance.svg'} /> */}
        {/* <Layer */}
        {/*   id={'energir-hazard-svg'} */}
        {/*   sourceId={'energir-hazard'} */}
        {/*   sourceLayer={'energir-hazard'} */}
        {/*   type='symbol' */}
        {/*   layout={{ */}
        {/*     'icon-image': 'default-2', */}
        {/*     'icon-size': 0.25 */}
        {/*   }} */}
        {/* /> */}
      </Fragment>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getFilter = makeGetFilter()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, paintId),
      time: state.layer.times[datetimeId || id] || undefined,
      datetime: getDatetime(state, datetimeId || id, getDatetimeForVectorTiles) || undefined,
      filter: getFilter(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event)),
      energirHazardDataUpdated: (json) =>
        dispatch(DataActions.dataFulfilled(json, 'energir-hazard')),
      pointDataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, `${id}Point`, event))
    }
  }
}


export default connect(makeMapStateToProps, mapDispatchToProps)(withSnackbar(EnergirChange))



// WEBPACK FOOTER //
// ./src/layers/EnergirChange.js